// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"564":"css/admin-app.6848","844":"css/app.6848"}[chunkId] + ".css";
};